/**
 * External dependencies
 */
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/tooltip';

/**
 * Internal dependencies
 */
import { cn } from '@Utils/cn';
import { Link, LinkProps } from 'react-router-dom';

type NavItemProps = LinkProps &
  React.ComponentProps<'li'> & {
    icon?: React.ReactNode;
    menuExpanded?: boolean;
    active?: boolean;
  };

export default function NavItem({
  className,
  children,
  to,
  // search,
  icon,
  menuExpanded,
  active,
}: NavItemProps) {
  return (
    <li className={cn(className)}>
      <Link
        to={to}
        // search={search}
        className={cn(
          'font-medium hover:text-zinc-200',
          active ? 'text-zinc-200' : 'text-zinc-400',
        )}
      >
        <div className="flex items-center">
          {icon &&
            (menuExpanded ? (
              <span
                className={cn(
                  'mr-2 shrink-0',
                  active ? 'opacity-100' : 'opacity-60',
                )}
              >
                {icon}
              </span>
            ) : (
              <Tooltip>
                <TooltipTrigger asChild>
                  <span
                    className={cn(
                      'mr-2 shrink-0',
                      active ? 'opacity-100' : 'opacity-60',
                    )}
                  >
                    {icon}
                  </span>
                </TooltipTrigger>
                <TooltipContent side="right">{children}</TooltipContent>
              </Tooltip>
            ))}
          <span
            className={cn(
              'shrink-0 overflow-hidden text-sm text-nowrap transition-all duration-200',
              menuExpanded ? 'w-full opacity-100' : 'w-0 opacity-0',
            )}
          >
            {children}
          </span>
        </div>
      </Link>
    </li>
  );
}
